import { render } from "./pencil.svg?vue&type=template&id=1c621092?inline"
const script = {}
script.render = render

export default script